
import React from "react";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { Lock, UserPlus, LogIn } from "lucide-react";

interface RestrictedAccessModalProps {
  open: boolean;
  onClose: () => void;
  featureName: string;
}

const RestrictedAccessModal: React.FC<RestrictedAccessModalProps> = ({
  open,
  onClose,
  featureName
}) => {
  const navigate = useNavigate();

  const handleRegister = () => {
    onClose();
    navigate("/cadastro");
  };

  const handleLogin = () => {
    onClose();
    navigate("/login");
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-center">
            <Lock className="w-5 h-5 text-primary" />
            Acesso Restrito
          </DialogTitle>
          <DialogDescription className="text-center">
            Para acessar <strong>{featureName}</strong>, é necessário se cadastrar ou entrar.
          </DialogDescription>
        </DialogHeader>
        
        <div className="bg-gradient-to-r from-primary/10 to-primary/5 border border-primary/20 rounded-lg p-4 my-4">
          <div className="flex items-center justify-center gap-2 mb-2">
            <UserPlus className="w-4 h-4 text-primary" />
            <span className="font-semibold text-primary text-sm">
              Cadastre-se Gratuitamente
            </span>
          </div>
          <p className="text-muted-foreground text-xs text-center">
            Acesse todas as ferramentas de IA para jogos e palpites inteligentes!
          </p>
        </div>

        <DialogFooter className="flex-col sm:flex-row gap-2">
          <Button variant="outline" onClick={onClose} className="w-full sm:w-auto">
            Fechar
          </Button>
          <Button onClick={handleLogin} variant="secondary" className="w-full sm:w-auto">
            <LogIn className="w-4 h-4 mr-2" />
            Entrar
          </Button>
          <Button onClick={handleRegister} className="w-full sm:w-auto">
            <UserPlus className="w-4 h-4 mr-2" />
            Cadastrar Agora
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default RestrictedAccessModal;
